import { CommonModule } from "@angular/common";
import { Component, OnInit } from "@angular/core";
import { TabsModule } from "primeng/tabs";
import { InvoicesComponent } from "../../components/invoices/invoices.component";
import { AccordionModule } from "primeng/accordion";
import { FormsModule } from "@angular/forms";
import { InvoicesDashboardComponent } from "src/app/components/invoices-dashboard/invoices-dashboard.component";
import { ConsumptionGraphComponent } from "../../components/consumption-graph/consumption-graph.component";
import { ConsumptionDashboardComponent } from "src/app/components/consumption-dashboard/consumption-dashboard.component";
import { ContractsComponent } from "../../components/contracts/contracts.component";
import { ContractsDashboardComponent } from "src/app/components/contracts-dashboard/contracts-dashboard.component";
import { CustomerDetailsComponent } from "src/app/components/customer-details/customer-details.component";
import { CustomerDashboardComponent } from "src/app/components/customer-dashboard/customer-dashboard.component";
import { PaymentMethodComponent } from "../../components/payment-method/payment-method.component";
import { PaymentMethodDashboardComponent } from "src/app/components/payment-method-dashboard/payment-method-dashboard.component";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { LoginService } from "src/app/services/login.service"; // Adjust the path as needed

@Component({
    selector: 'mijn-ebem-page',
    standalone: true,
    templateUrl: './mijn-ebem.page.html',
    styleUrls: ['./mijn-ebem.page.scss'],
    imports: [AccordionModule, ButtonModule, CardModule, CommonModule, FormsModule, TabsModule, InvoicesDashboardComponent, InvoicesComponent, ConsumptionDashboardComponent, ConsumptionGraphComponent, ContractsDashboardComponent, ContractsComponent, CustomerDashboardComponent, CustomerDetailsComponent, PaymentMethodDashboardComponent, PaymentMethodComponent],
    providers: [LoginService],
})
export class MijnEbemPage implements OnInit {

    constructor(private LoginService: LoginService) {
    }

    ngOnInit(): void {
        this.LoginService.login({ userName: 'K2076247-59', password: 'K2076247-59' }).subscribe(response => {
            console.log(response); // Handle the response as needed
        },
            error => {
        console.error('Login failed', error); // Handle the error as needed
        });
    }

    activeTab: string = 'overview';
}